import React from 'react';
import {
  Divider,
  FormControl,
  Button,
  Box,
  Typography,
  InputAdornment,
  IconButton
} from '@mui/material';
import api from "../../services/api";
import {
  TextField,
} from '../../components';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import { useStoreActions } from 'easy-peasy';
import PasswordIcon from '@mui/icons-material/Password';
import { Visibility, VisibilityOff } from '@mui/icons-material';
yup.setLocale(pt);



const Senha = () => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const onClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const mouseDownNewPassword = (event) => {
    event.preventDefault();
  };
  const onClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  const mouseDownConfirmPassword = (event) => {
    event.preventDefault();
  };




  const schema = yup.object({
    password: yup.string()
      .label('Senha atual').required(),
    newPassword: yup.string()
      .label('Nova senha').required(),
    confirmPassword: yup.string()
      .label('Confirmar nova senha').required()
      .oneOf([yup.ref('newPassword')],
             'A confirmação da senha deve ser igual a nova senha'),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
  });

  const { handleSubmit, reset,
          formState: {isDirty, isSubmitting} } = useFormRef;

  const submit = async (data) => {
     startLoading();
    try {
      await api.http.put('auth-user',data);
      stopLoading({ severity: 'success' });
      reset();
    } catch(error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
 };

  return (
    <div>
      <Divider>

        <Typography variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
          <PasswordIcon sx={{'mr':1}}/> Minha senha de acesso
        </Typography>
      </Divider>
      <form onSubmit={handleSubmit(submit)} >
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="password" type={showPassword ? 'text' : 'password'}
                     schema={schema} useFormRef={useFormRef}
                     InputProps={{
                      endAdornment: <InputAdornment position="start">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="start"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }}
                     
                     />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="newPassword" type={showNewPassword ? 'text' : 'password'}
                     schema={schema} useFormRef={useFormRef}
                     InputProps={{
                      endAdornment: <InputAdornment position="start">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={onClickShowNewPassword}
                          onMouseDown={mouseDownNewPassword}
                          edge="start"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }}
                     />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="confirmPassword" type={showConfirmPassword ? 'text' : 'password'}
                     schema={schema} useFormRef={useFormRef}
                     InputProps={{
                      endAdornment: <InputAdornment position="start">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={onClickShowConfirmPassword}
                          onMouseDown={mouseDownConfirmPassword}
                          edge="start"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }} 
                     />
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" size="large"
                  disabled={!isDirty || isSubmitting}>ALTERAR</Button>
        </Box>
      </form>
    </div>
  );
};

export default Senha;
